<template>
  <v-app>
    <notifyWrapper/>
    <RefreshAppAlert />
    <!-- APPLICATION BAR  -->
    <v-app-bar
      style="box-shadow:0 0 20px rgba(0, 0, 0, 0.13)"
      id="home-app-bar"
      flat
      app
      color="#F5F6F7"
    >
    <v-btn v-if="needShowBurgerMenu" icon @click="drawer = !drawer">
      <v-icon>mdi mdi-menu</v-icon>
    </v-btn>
      <v-col lg="3" class="search-container">
        <v-text-field
          flat
          solo
          background-color="transparent"
          hide-details
          append-icon="mdi-magnify"
          :label="$t('components.main.search')"
          class="hidden-sm-and-down"
          v-model="globalSearch"
          :disabled="showChangePasswordDialog"
        ></v-text-field>
      </v-col>

      <v-col v-if="topToolbarButtonEvent" class="w-100 top-toolbar-event-container">
        <v-select
          v-model="activeItem"
          :label="topToolbarButtonEventCaption"
          :items="eventItems"
          hide-details
        ></v-select>
      </v-col>
      <v-spacer v-else/>

      <lang-switcher />
      <notifications color="orange"/>
      <v-menu offset-y min-width="300">
        <template v-slot:activator="{ on }">
          <v-list dense style="background:transparent;" class="py-0 user-avatar-container">
            <v-list-item v-on="on" two-line :class="'px-3'">
              <user-photo-upload
                v-if="authData && canChangeUserPhoto"
                @photo-updated="onUserPhotoUpdated"
                @short-touch="on.click"
              >
                <v-list-item-avatar class="editable-user-avatar">
                  <v-img v-if="!needDefaultImage" :src="getUserPhoto()" @load="load() " @error="error()"/>
                  <img v-else src="../assets/user-account.png"/>
                  <v-icon class="avatar-edit-icon">mdi-camera</v-icon>
                </v-list-item-avatar>
              </user-photo-upload>
              <v-list-item-avatar v-else-if="authData">
                <v-img v-if="!needDefaultImage" :src="getUserPhoto()" @load="load() " @error="error()"/>
                <img v-else src="../assets/user-account.png"/>
              </v-list-item-avatar>

              <v-list-item-content v-if="authData" style="flex-direction:column; align-items:start" class="user-info-container">
                <v-list-item-title>{{ getUserName() }}</v-list-item-title>
                <v-list-item-subtitle>{{ getUserLogin() }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
        <v-list class="user-actions-container">
          <v-list-group
            v-if="$store.getters.appModel.ProjectSecurity.DelegateRigthsAvailable && delegateRigths.Items.length > 0"
            no-action
            @click.native.stop.prevent
            class="delegate-rigths-container"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ delegateRigths.Text }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in delegateRigths.Items"
              :key="i"
              class="pl-6"
              @click="onDelegateRigthsClick(item.tag)"
            >
              <v-icon :class="{'hidden': delegateRigths.ActiveItem !== item.tag}">mdi-check</v-icon>
              <v-list-item-title >{{ item.caption }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item v-if="canChangePassword" @click="openChangePasswordDialog">
            <div class="uap-action uap-user-change-pass">{{$t('menuLayout.changePassword')}}</div>
          </v-list-item>
          <v-list-item v-if="reportProblemAvailable" class="report-problem-btn" @click="onReportProblem">
            <v-list-item-title >{{$t('login.reportProblem')}}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$authCore.SignOut()">
            <v-list-item-title >{{$t('login.signOut')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- NAVIGATION -->

    <v-navigation-drawer
      :right="$vuetify.rtl"
      elevation="1"
      floating
      app
      v-model="drawer"
      :expand-on-hover="minidrawer && !pinned"
      width="300"
      :mini-variant="!pinned"
    >
      <div class="logo">
        <img
          :src="logoUrl"
          height="33px"
          class="pl-3 full-logo"
        />
        <div v-if="!needShowBurgerMenu && canPinMenu" class="full-logo ml-auto pin-btn">
          <v-icon v-if="!pinned" @click="pinned = !pinned">mdi-pin</v-icon>
          <v-icon v-else @click="pinned = !pinned">mdi-pin-off</v-icon>
        </div>
        <img :src="minLogoUrl" height="33px" class="pl-3 small-logo" />
      </div>

      <NavigationMenu :items="sidebarItems" />
    </v-navigation-drawer>

    <!-- CONTENT -->
    <v-main  style="background:#f1f4f6">
      <v-progress-linear
      v-if="loader"
      indeterminate
      height="5"
      color="primary"
      absolute
      ></v-progress-linear>
      <v-container fluid>
        <dr-layout-placeholder :model="{$ID:'pl3'+this.routeName, Name:'Main'}"></dr-layout-placeholder>
      </v-container>
      <change-password-dialog v-model="showChangePasswordDialog" v-if="showChangePasswordDialog" @closeDialog="closeDialog" :hideCloseBtn="$authCore?.store.state.auth.user.NeedChangePassword"/>
    </v-main>
  </v-app>
</template>

<script>
import { MainMenuApi as api } from '../mainMenuSrc/api/api.js'
import LangSwitcher from '@/components/LangSwitcher'
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'
import layoutMixin from '@it-enterprise/web-app-common/src/mixins/layout-mixin'
import NotifyWrapper from '@/components/NotifyWrapper'
import Notifications from '@/components/Notifications'
import RefreshAppAlert from '@/components/RefreshAppAlert'
import UserPhotoUpload from '@/components/UserPhotoUpload'
export default {
  name: 'MainLayout',
  mixins: [inputMixin, layoutMixin],
  components: {
    LangSwitcher,
    NotifyWrapper,
    Notifications,
    RefreshAppAlert,
    UserPhotoUpload,
    changePasswordDialog: () => import('../mainMenuSrc/components/dialogs/changePasswordDialog.vue')
  },
  data: () => ({
    drawer: true,
    minidrawer: true,
    items: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard' },
      { title: 'Photos', icon: 'mdi-image' },
      { title: 'About', icon: 'mdi-help-box' }
    ],
    needDefaultImage: false,
    showChangePasswordDialog: false,
    pinned: false,
    userActions: [],
    delegateRigths: {
      Text: '',
      ActiveItem: {},
      Items: [],
      ServiceItems: []
    },
    activeItemValue: null,
    eventItems: []
  }),
  computed: {
    eventHandlers() {
      let appEventHandlers = this.$store.getters.appModel.UserModel?.Settings?.EventHandlers ?? this.$store.getters.appModel.Settings?.EventHandlers
      return appEventHandlers || {}
    },
    topToolbarButtonEvent() {
      return !!this.eventHandlers.TopToolbarButtonEvent
    },
    topToolbarButtonEventCaption() {
      return this.eventHandlers.TopToolbarButtonEventCaption || ''
    },
    reportProblemAvailable() {
      return !!this.eventHandlers.ReportingProblemEventHandlerValue
    },
    canChangePassword() {
      if (this.authData?.isLdapUser === 'true') {
        return false
      }
      if (this.$store.state.general.config.passwordChangeAvailable) {
        return this.$store.state.general.config.passwordChangeAvailable === '+'
      }
      return this.$store.getters.appModel.ProjectSecurity.PasswordChangeAvailable
    },
    canChangeUserPhoto() {
      return this.$store.getters.appModel.ProjectSecurity.UserPhotoChangeAvailable !== false
    },
    authData() {
      return this.$store.state.auth.user?.authData || null
    },
    routeName() {
      return this.$route.name
    },
    sidebarItems() {
      return this.$store.getters.AppNavigation
    },
    loader() {
      return this.$store.getters.getProcessing
    },
    needShowBurgerMenu() {
      if (this.$vuetify.breakpoint.name == 'xl' || this.$vuetify.breakpoint.name == 'lg') { 
        this.setModeDrawer(true)
        return false
      }
      this.setModeDrawer(true)
      return true
    },
    canPinMenu() {
      const settings = this.$store.getters.appModel.UserModel?.Settings?.UIAdditionalSettings ?? this.$store.getters.appModel.Settings?.UIAdditionalSettings
      return settings ? settings.pinMenus : false
    },
    globalSearch: {
      get() {
        return this.$store.state.general.globalSearch
      },
      set(v) {
        this.$store.commit('SET_GLOBAL_SEARCH', v)
      }
    },
    activeItem: {
      get() {
        return this.activeItemValue
      },
      set(val) {
        this.setItem(val)
      }
    }
  },
  methods: {
    async setItem(val) {
      this.activeItemValue = val
      await this.$jsActionsRunner.callJsActions(this.eventHandlers.TopToolbarButtonEventHandler, { value: val })
    },
    async getItem() {
      this.activeItemValue = await this.$jsActionsRunner.callJsActions(this.eventHandlers.TopToolbarButtonEventHandlerValue)
    },
    async getItems() {
      this.eventItems = await this.$jsActionsRunner.callJsActions(this.eventHandlers.TopToolbarButtonEventHandlerValues) || []
    },
    onReportProblem() {
      this.$jsActionsRunner.callJsActions(this.eventHandlers.ReportingProblemEventHandlerValue)
    },
    setModeDrawer(value) {
      this.minidrawer = value
    },
    load() {
      this.needDefaultImage = false
    },
    error() {
      this.needDefaultImage = true
    },
    openChangePasswordDialog() {
      if (this.$store.getters.appModel.ProjectSecurity.ChangeWithSmartId) {
        window.location.href = `${this.$store.state.general.config.oidc.authority}UserProfile/PasswordChange?returnurl=${window.location.href}&client_id=${this.$store.state.general.config.oidc.client}`
      } else {
        this.showChangePasswordDialog = true
      }
    },
    closeDialog() {
      this.showChangePasswordDialog = false
    },
    getUserName() {
      return window.sessionStorage.getItem('userName') || this.$store.state.auth.user?.authData?.userName
    },
    getUserPhoto() {
      const delegatedUserPhoto = window.sessionStorage.getItem('userPhoto')
      const userPhoto = window.sessionStorage.getItem('userPhoto2')
      const authData = this.$store.state.auth.user?.authData
      return delegatedUserPhoto || userPhoto || authData?.userPhoto
    },
    onUserPhotoUpdated(photo) {
      window.sessionStorage.setItem('userPhoto2', photo)
      this.needDefaultImage = false
      this.$forceUpdate()
    },
    getUserLogin() {
      return window.sessionStorage.getItem('userPhoto') && window.sessionStorage.getItem('userName')
        ? ''
        : this.$store.state.auth.user?.authData?.login
    },
    async onDelegateRigthsClick(value) {
      let data = await api.doRmdUserAction('6', value)
      if (data.data.iTEnterpriseMenuMutation.doRmdUserAction.success) {
        if (this.$store.state.auth.user.authData.id == value) {
          window.sessionStorage.removeItem('userName')
          window.sessionStorage.removeItem('userPhoto')
          window.sessionStorage.removeItem('delegateUserId')
        } else {
          let result = JSON.parse(data.data.iTEnterpriseMenuMutation.doRmdUserAction.result)
          window.sessionStorage.setItem('userName', result.UserName)
          window.sessionStorage.setItem('userPhoto', result.UserPhoto)
          window.sessionStorage.setItem('delegateUserId', value)
        }
      }
      window.location.href = location.href
    }
  },
  async mounted() {
    if (this.topToolbarButtonEvent) {
      await this.getItem()
      await this.getItems()
    }
    if (this.$authCore?.store.state.auth.user.NeedChangePassword && this.authData?.isLdapUser !== 'true') {
      this.showChangePasswordDialog = true
    }
    if (this.$store.getters.appModel.ProjectSecurity.DelegateRigthsAvailable && this.userActions.length == 0) {
      let data = await api.getUserActions()
      this.userActions = data.data.iTEnterpriseMenuQuery.getUserActions.items
      for (let i = 0; i < this.userActions.length; i++) {
        if (this.userActions[i].items.length) {
          if (this.userActions[i].key == 'AddDelegateRigths') {
            this.delegateRigths.Text = this.$t('menuLayout.settingsLayout.delegateRigths')
            this.delegateRigths.Items = this.userActions[i].items.filter(item => item.tag)
            this.delegateRigths.Items.forEach(item => { 
              item.caption = item.text
              item.text = this.delegateRigths.Text
            })
          }
          this.delegateRigths.ActiveItem = this.userActions[i].items.find(item => item.isActive)?.tag
        }
      }
    }
  }
}
</script>

<style lang="scss">
.editable-user-avatar {
  position: relative;
  transition: box-shadow 0.2s ease;

  &::after {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.45);
    content: '';
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
  }

  .avatar-edit-icon {
    position: absolute;
    z-index: 2;
    color: #fff;
    font-size: 20px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
  }
}

@media (hover: hover) and (pointer: fine) {
  .user-photo-upload:hover,
  .user-photo-upload:focus-within {
    .editable-user-avatar {
      box-shadow: 0 0 0 2px var(--v-primary-base, #1976d2);

      &::after,
      .avatar-edit-icon {
        opacity: 1;
      }
    }
  }
}

@media (hover: none), (pointer: coarse) {
  .user-photo-upload.long-press-active {
    .editable-user-avatar {
      &::after,
      .avatar-edit-icon {
        opacity: 1;
      }
    }
  }
}

.user-actions-container {
  .delegate-rigths-container {
    .hidden {
      visibility: hidden;
    }
    .v-list-group__items {
      max-height: 400px;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 14px;
      }
      
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      
      &::-webkit-scrollbar-thumb {
        background-color: #C7C7D1;
        border-radius: 8px;
        border: 4px solid transparent;
        background-clip: content-box;
      }
      
      &::-webkit-scrollbar-thumb:hover {
        background-color: #a8bbbf;
      }

      .v-list-item {
        width: 280px;
      }
    }
  }
}

.search-container {
  padding: 0px 12px;

  @media screen and (min-width: 320px) {
    .hidden-sm-and-down {
      display: flex !important;
    }
  }
}

@media screen and (max-width: 768px) {
  #home-app-bar {
    .spacer {
      flex-basis: 10%;
    }

    .search-container {
      flex-basis: 90%;
    }
  }
}

@media screen and (max-width: 320px) {
  #home-app-bar {
    .v-toolbar__content {
      padding-right: 0px;
    }

    .search-container {
      padding: 0px;

      .v-input__slot {
        padding: 0px 4px;
      }
    }
  }
}

@media screen and (max-width: 560px) {
  #home-app-bar {
    .spacer {
      display: none;
    }

    .user-avatar-container {
      flex-shrink: 0;
      padding: 0px !important;
      width: 48px;
      height: 48px;
      border-radius: 48px;
      overflow: hidden;

      .v-list-item {
        justify-content: center;
        min-height: 48px !important;
      }

      .v-avatar {
        margin: 0px;
      }

      .user-info-container {
        display: none;
      }
    }
  }
}

nav.v-navigation-drawer {
  box-shadow: 0 0px 18px 0px rgba(0, 0, 0, 0.06);
  height: -webkit-fill-available !important;
}
.small-logo {
  display: none;
}
.logo {
  height: 75px;
  background: #fafbfc;
  display: flex;
  align-items: center;
}
.v-navigation-drawer--mini-variant {
  .full-logo {
    display: none;
  }
  .small-logo {
    display: block;
  }
}

.drawer-toggler {
  $border: 1px solid #e2e5e7;
  display: flex;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 0;
  top: 25px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-left: $border;
  border-top: $border;
  border-bottom: $border;
  cursor: pointer;
  z-index: 1000;
  i {
    display: block;
    font-size: 20px;
  }
}

.pin-btn {
  width: 34px;
}
</style>